export const billingEventsFiscalDocumentsStatus = {
  pending: 'Pendente',
  uploaded: 'Aguardando aprovação',
  confirmed: 'Confirmada',
  rejected: 'Rejeitada',
};

export const billingEventsFiscalDocumentsStatusOptions = Object.entries(billingEventsFiscalDocumentsStatus).map(([value, label]) => ({ value, label }));
